var map = {
	"./3modes.png": 5695,
	"./Before and After.png": 2906,
	"./code.png": 9985,
	"./coding.png": 8328,
	"./cover.png": 1377,
	"./cover3.png": 3374,
	"./delete.png": 9919,
	"./fdlogo.svg": 413,
	"./problem.png": 6905,
	"./tokenchain.png": 3860,
	"./tokenexample.png": 4341,
	"./tokenplugin.gif": 1813,
	"./tokenspec.png": 4782,
	"./tokenspec1.png": 9109,
	"./tokenspec2.png": 8750,
	"./tokenupdate.gif": 6987
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1832;